import React, { useState, useEffect } from "react";
import { AmeaRoutesDataContext } from "./context";

import { getAmeaData } from "../services/services";

const AmeaRoutesProvider = ({ children }) => {
  const [AmeaRoutesData, setAmeaRoutesData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setAmeaRoutesData([]);
    const fetchAmeaRoutes = async () => {
      const AmeaRoutes = await getAmeaData("routes")
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });
      const tempAmeaRoutes = AmeaRoutes.map((route) => {
        const tempRoute = route;
        if (tempRoute?.linestring) {
          tempRoute.linestring = tempRoute?.linestring?.map((linestringSet) => {
            return {
              lat: linestringSet[0],
              lng: linestringSet[1],
            };
          });
          return tempRoute;
        }
      });
      setAmeaRoutesData(tempAmeaRoutes);
    };

    fetchAmeaRoutes();
  }, []);

  return (
    <AmeaRoutesDataContext.Provider
      value={{ AmeaRoutesData, setAmeaRoutesData, loading, error }}
    >
      {children}
    </AmeaRoutesDataContext.Provider>
  );
};

export default AmeaRoutesProvider;
